import axios from 'axios'

export default {
  current: function (request) {
    return axios.get('/api/journalroute/current', { params: request })
  },
  history: function (request) {
    return axios.get('/api/journalroute/RouteHistory', { params: request })
  },  
  loadRoutes: function() {
    return axios.get('/api/route/search', { params: {pageNumber: 1, pageSize: -1} });
  },
  find: function(id) {
    return axios.get('/api/route/find?id='+id)
  },
  confirmStep: function (id, numImar, dateImar) {
    if (numImar && dateImar)
      return axios.post(`/api/journalroute/confirmStep`, null, {params: {signerCurrentId: id, numImar, dateImar}}) //?signerCurrentId=${id}&numImar=${numImar}&dateImar=${dateImar}`)

    return axios.post('/api/journalroute/confirmStep?signerCurrentId=' + id)
  },  
  rejectStep: function (id, comment, routeId) {
    return axios.post('/api/journalroute/rejectStep?signerCurrentId=' + id + '&comment='+comment + '&routeId='+routeId)
  },   
  undoStep: function (id) {
    return axios.post('/api/journalroute/undoStep?signerCurrentId=' + id)
  },     
  loadOrganizationList: function(permissionName) {
    return axios.get('/api/organizations/getlist', {
      params: {
        search: null,
        serviceTypeId: null,
        includeRoles: false,
        permissionName: permissionName
      }
    });
  },
  getNextNumImar: function (journalId) {
    return axios.get('/api/journalroute/getNextNumImar?journalId='+ journalId);
  }   
}